// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2_gJm","lead":"styles_lead__2OywF","charts":"styles_charts__2Q9si","note":"styles_note__1F_mg"};